import BaseView from './BaseView';
import ImageCarousel from '../../modules/ImageCarousel';
import FeaturedArtistsCarousel from '../../modules/FeaturedArtistsCarousel';
import EventsHeader from '../../components/EventsHeader';
import ProgramEvent from '../../components/ProgramEvent';
import ReadMore from '../../components/ReadMore';
import RevealBio from '../../components/RevealBio';
import FeaturedArtist from '../../components/FeaturedArtist';


import { gsap } from 'gsap';

let view = null;

class Serie extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		this.container.querySelectorAll('[data-image-carousel]').forEach((el) => {
			this.modules.push(new ImageCarousel(el));
		});

		const portfolioEl = this.container.querySelector('[data-serie]');
		if(portfolioEl) {
			new FeaturedArtist(portfolioEl);
		}

		this.container.querySelectorAll('[data-artists-carousel]').forEach((el) => {
			this.modules.push(new FeaturedArtistsCarousel(el));
		});


		const eventsHeaderElm = this.container.querySelector('[data-events-header]');
		if(eventsHeaderElm) {
			this.eventsHeader = new EventsHeader(eventsHeaderElm, this.modules);
			this.modules.push(this.eventsHeader);
		}

		this.container.querySelectorAll('[data-event]').forEach((el) => {
			this.modules.push(new ProgramEvent(el));
		});

		this.container.querySelectorAll('[data-readmore]').forEach((el) => {
			this.modules.push(new ReadMore(el));
		});

		this.container.querySelectorAll('[data-artist]').forEach((el) => {
			this.modules.push(new RevealBio(el));
		});

		this.breakpoint = window.matchMedia('(min-width:992px)');

	}

	scrollToSection(targetID, duration = 0) {
		this.eventsHeader.activateTab(targetID);
		const targetSection = this.container.querySelector(targetID);

		if (targetSection) {
			let targetTop = 0;

			if(this.breakpoint.matches) { // Desktop
                targetTop = targetSection.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 63 - 46; // 63 header height, 46 filter height
            } else { // Mobile
                targetTop = targetSection.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 78 - 70; // 70 header height, 70 filter height

                if(!document.body.classList.contains('body--has-scrolled-down')) {
                    if(window.scrollY>targetTop) {
                        targetTop = targetTop;
                    } else {
                        targetTop = targetTop + 34;
                    }
                } else {
                    if(window.scrollY>targetTop) {
                        targetTop = targetTop - 34;
                    } else {
                        targetTop = targetTop;
                    }
                }
                targetTop = targetTop + 1;
            }

			gsap.to(window, {
				duration: duration,
				ease: 'power2.inOut',
				scrollTo: {
					y: targetTop,
				},
			});
		}
	}

}

export default {
	namespace: 'single-serie',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Serie(next.container);
		view.init();
	},
	afterEnter: ({ current, next, trigger, four }) => {
        view.afterEnterFunctions();
    },
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};